import type { ChangeEvent, FocusEvent } from 'react'
import React from 'react'
import { InfoTooltip } from '../../common/InfoTooltip'
import { withFormikSupport } from '../../hocs/withFormikSupport'
import { CheckboxIcon } from './CheckboxIcon'
import * as S from './styled'
import type { CheckboxProps } from './types'

export const CheckboxComponent = ({
  label,
  labelAlign = 'start',
  description,
  tooltip,
  size = 'medium',
  indeterminate,
  id,
  name,
  value,
  checked,
  disabled,
  native,
  onChange,
  onValueChange,
  onBlur,
}: CheckboxProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e)
    }

    if (onValueChange) {
      onValueChange(e.target.checked)
    }
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e)
    }
  }

  const renderTooltip = () => {
    if (!tooltip) return null

    return (
      <S.TooltipContainer>
        <InfoTooltip content={tooltip} />
      </S.TooltipContainer>
    )
  }

  const getChecked = () => {
    if (native) return checked

    return typeof value === 'boolean' ? value : undefined
  }

  return (
    <S.Container>
      <S.Label $disabled={Boolean(disabled)} $labelAlign={labelAlign} data-testid="Checkbox">
        {/* We need to wrap input in div to be able to position CheckboxIcon on top of it and correctly apply margins to label */}
        <div>
          <S.Input
            type="checkbox"
            id={id}
            name={name}
            value={typeof value === 'string' ? value : undefined}
            checked={getChecked()}
            disabled={disabled}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <CheckboxIcon size={size} indeterminate={indeterminate} />
        </div>
        {(label || description) && (
          <div>
            {label && <S.Text $disabled={Boolean(disabled)}>{label}</S.Text>}
            {description && <S.Description>{description}</S.Description>}
          </div>
        )}
      </S.Label>
      {renderTooltip()}
    </S.Container>
  )
}

export const Checkbox = withFormikSupport(CheckboxComponent)
